(function () {
  const setHeaderHeight = () => {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  };

  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('shopify:section:load', setHeaderHeight);
})();

// SUBMENÚ ARTISTAS

document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector("[data-artist-subnav]");
  if (!nav) return;

  const links = [...nav.querySelectorAll(".artist-subnav__link")];

  const sections = links
    .map((link) => {
      const href = link.getAttribute("href");
      if (!href || !href.startsWith("#")) return null;

      const section = document.querySelector(href);
      if (!section) return null;

      return { link, section };
    })
    .filter(Boolean);

  const placeholder = document.createElement("div");
  placeholder.style.display = "none";
  placeholder.style.height = "0px";
  nav.parentNode.insertBefore(placeholder, nav);

  const getHeaderHeight = () => {
    const v = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-height")
      .trim();

    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 64;
  };

  const fix = () => {
    if (nav.classList.contains("is-fixed")) return;

    placeholder.style.height = `${nav.offsetHeight}px`;
    placeholder.style.display = "block";
    nav.classList.add("is-fixed");
  };

  const unfix = () => {
    if (!nav.classList.contains("is-fixed")) return;

    nav.classList.remove("is-fixed");
    placeholder.style.display = "none";
    placeholder.style.height = "0px";
  };

  const updateFixed = () => {
    const headerH = getHeaderHeight();

    const anchorRect =
      nav.classList.contains("is-fixed")
        ? placeholder.getBoundingClientRect()
        : nav.getBoundingClientRect();

    if (anchorRect.top <= headerH) {
      fix();
    } else {
      unfix();
    }
  };

  const centerActiveLinkHorizontally = (activeLink) => {
    const scroller = nav.querySelector(".artist-subnav__inner");
    if (!scroller) return;
    if (scroller.scrollWidth <= scroller.clientWidth) return;

    const linkLeft = activeLink.offsetLeft;
    const linkWidth = activeLink.offsetWidth;
    const targetLeft = linkLeft - scroller.clientWidth / 2 + linkWidth / 2;

    scroller.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: "smooth"
    });
  };

  const updateActive = () => {
    if (!sections.length) return;

    const offset = getHeaderHeight() + nav.offsetHeight + 24;
    let current = sections[0];

    sections.forEach((item) => {
      const top = item.section.getBoundingClientRect().top;

      if (top <= offset) {
        current = item;
      }
    });

    links.forEach((link) => link.classList.remove("is-active"));
    current.link.classList.add("is-active");

    centerActiveLinkHorizontally(current.link);
  };

  const update = () => {
    updateFixed();
    updateActive();
  };

  update();

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
});


/* FILTROS CERRADOS */

(function () {
  const closeFacetDetails = () => {
    document.querySelectorAll('.facets__details').forEach((item) => {
      item.removeAttribute('open');
      item.open = false;
    });
  };

  const initClosedFacets = () => {
    closeFacetDetails();

    requestAnimationFrame(() => {
      closeFacetDetails();

      setTimeout(() => {
        closeFacetDetails();
      }, 50);
    });
  };

  document.addEventListener('DOMContentLoaded', initClosedFacets);
  window.addEventListener('load', initClosedFacets);
  document.addEventListener('shopify:section:load', initClosedFacets);

  const observer = new MutationObserver(() => {
    closeFacetDetails();
  });

  document.addEventListener('DOMContentLoaded', () => {
    const target =
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('#main-collection-filters') ||
      document.body;

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  });
})();